import { GeneralReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';

const initialState: GeneralReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
  data: null,
};

const usageReducer = createReducer(initialState, {
  GET_GENERAL_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  GET_GENERAL_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.data = action.payload.data;
  },

  GET_GENERAL_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.data = action.payload.data;
  },
});

export default usageReducer;
